import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_STATUSES } from "../../../utils/constants";
import statusService from "../../../services/ticketService/statusService";
import { StatusInterface } from "../../../models/TicketModule/Status";

interface AddStatusesContext {
  previousStatuses: StatusInterface[];
}

const useAddStatus = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    StatusInterface,
    Error,
    StatusInterface,
    AddStatusesContext
  >({
    mutationFn: statusService.Save,

    onMutate: () => {
      const previousStatuses =
        queryClient.getQueryData<StatusInterface[]>([
          CACHE_KEY_STATUSES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousStatuses };
    },

    onSuccess: (savedStatus) => {
      queryClient.setQueryData<StatusInterface[]>(
        [
          CACHE_KEY_STATUSES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (statuses) => (statuses ? [savedStatus, ...statuses] : [savedStatus])
      );
    },

    onError: (error, newSatus, context) => {
      if (!context) return;

      queryClient.setQueryData<StatusInterface[]>(
        [
          CACHE_KEY_STATUSES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousStatuses
      );
    },
  });
};

export default useAddStatus;
